'use client';

import { FC } from 'react';
import Link from 'next/link';
import styles from '../fbt-grid/fbt-grid.module.scss';
import { useSelectItemEvent } from 'hooks/analytics/use-select-item-event';
import { FBT_LIST_NAME } from '../../../constants/constants';
import { getFormattedSearchSelectItemHeadless } from 'components/product-comparison-grid/product-comparison-card/utils';
import { useFbtContext } from '../fbt-context/fbt-context-provider';
import { getItemByPartNumber } from '../utils';

interface FbtCardTitleProps {
  partNumber: string;
  name: string;
  storeLocationId: string;
}

const FbtCardTitle: FC<FbtCardTitleProps> = ({
  partNumber,
  name,
  storeLocationId
}) => {
  const { fireEvent: fireSelectItemEvent } = useSelectItemEvent();
  const { cartDetails, fbtProductsWithPrice, itemSummary } = useFbtContext();

  const cartId = cartDetails?.orderHeader?.orderId;

  const handleSelectItemGa = () => {
    const partPrice = getItemByPartNumber(partNumber, fbtProductsWithPrice);
    const selectedItemSummary = getItemByPartNumber(
      partNumber,
      itemSummary?.products
    );

    fireSelectItemEvent({
      item: getFormattedSearchSelectItemHeadless(
        { orderId: cartId },
        partPrice
      ),
      partName: `${partPrice?.partNumber}: ${name}`,
      locationId: storeLocationId,
      itemSummary: {
        categoryPath: selectedItemSummary?.categoryPath,
        manufacturer: selectedItemSummary?.manufacturer ?? 'Cat'
      },
      isSearchPageEvent: true,
      itemListId: FBT_LIST_NAME,
      itemListName: FBT_LIST_NAME,
      serialNumber: '',
      fitment: ''
    });
  };

  return (
    <Link
      href={partNumber}
      onClick={handleSelectItemGa}
      className={`text-decoration-underline cat-u-theme-typography-body ${styles['c-fbt-card__title']}`}
    >{`${partNumber}: ${name}`}</Link>
  );
};

export default FbtCardTitle;
